import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import { quoteService } from "@/data/mock-quotes";
import type { QuoteRequest } from "@/types/quote";

/**
 * Hook per rilevare il contesto della quote request per FREIGHT_FORWARDER
 * Se siamo in una pagina di dettaglio quote, restituisce quella quote
 * Altrimenti restituisce null
 */
export const useQuoteContext = (): QuoteRequest | null => {
    const location = useLocation();
    const params = useParams<{ id?: string }>();
    const [quoteRequest, setQuoteRequest] = useState<QuoteRequest | null>(null);

    useEffect(() => {
        // Verifica se siamo in una pagina di dettaglio quote
        // Pattern: /freight-forwarder/quotes con quote selezionata
        // Oppure se c'è un ID nei params
        if (params.id) {
            const quote = quoteService.getById(params.id);
            if (quote) {
                setQuoteRequest(quote);
                return;
            }
        }

        // Verifica se c'è una quote selezionata nel localStorage o nello stato
        // (per la pagina quotes/index.tsx che ha selectedQuote nello stato)
        // Questo è un workaround - idealmente dovremmo usare un context o state management
        // Per ora controlliamo se siamo nella pagina quotes
        if (location.pathname.startsWith('/freight-forwarder/quotes')) {
            // Non possiamo accedere direttamente allo stato del componente padre
            // Quindi restituiamo null e lasceremo che il wizard gestisca la selezione
            setQuoteRequest(null);
        } else {
            setQuoteRequest(null);
        }
    }, [location.pathname, params.id]);

    return quoteRequest;
};

